import { useState } from "react"

import { Select } from "@minuthq/meatball-ui-react"

export function InstallConsoleCommandList({
  sendCommand,
  setCommand,
  hidden,
}: {
  sendCommand: (command: string) => void
  setCommand: (command: string) => void
  hidden?: boolean
}) {
  const [selectCommand, setSelectCommand] = useState<string>("")
  // const [, setCommand] = useState<string>()

  if (hidden) {
    return null
  }

  return (
    <Select
      label="Commands"
      value={selectCommand}
      onChange={(value) => {
        if (!value) {
          return
        }
        const inp: string = value
        setSelectCommand(inp)
        if (inp[0] === "#") {
          const s: string = value.replace(/#\w?/, "")
          setCommand(s)
          return // deferred command, manual input
        } else {
          sendCommand(inp)
        }
      }}
      options={[
        { label: "Help", value: "help" },
        { label: "Blink", value: "led blink" },
        { label: "Evil glow", value: "led color 1 1 255" },
        { label: "Play beep", value: "playbeep 100 500 1000 20000 10000" },
        {
          label: "Dubstep Mode",
          value: "led color 1 255 1 && playbeep 50 300 500 25000 10000",
        },
        {
          label: "Inject motion event",
          value: "tss inject EVENT PASSIVE_INFRARED 10",
        },
      ]}
    />
  )
}
